import React from 'react';
import Box from '@mui/material/Box';

const LoginBackground: React.FC = () => {

  return (
    <Box
      component="img"
      sx={{
        height: '100vh',
        width: '100vw',
        position: 'absolute'
      }}
      alt="Login Background"
      src={require('../../assets/icons/login/juyt_6.jpg')}
    />
  );
};

export default LoginBackground;